import * as Sentry from "@sentry/react";

export const breadcrumb = (category: string, message: string, data: Record<string, any> = {}) => {
    Sentry.addBreadcrumb({
        category,
        message,
        data
    });
}
